'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/enzyme-shallow-equal/~/has/src/index.js
// module id = 979
// module chunks = 0